import { BasicButtonInverted } from 'components/button/button.styled'
import { EventCardListing } from 'components/eventCard/eventCardListing'
import { LoadingContainer } from 'components/loadingContainer'
import { PlaceholderContainer } from 'components/placeholder'
import { useClosestEvents } from 'hooks/user/useEvents/useClosestEvents'
import { useNavigate } from 'react-router-dom'
import { EventType } from 'types/Event'

import { ButtonContainer, CardContainer, Container, Title } from './events.style'

interface Props {
    data: EventType[] | undefined
    isLoading: boolean
    error: any
}

export const LandingEvents = ({ data, isLoading, error }: Props) => {
    const navigate = useNavigate()
    const closestEvents = useClosestEvents(data, 4)

    const handleClick = () => {
        navigate(`/esemenyek/`)
    }

    return (
        <Container>
            <Title>Közelgő műsoraink</Title>
            <LoadingContainer isLoading={isLoading} error={error}>
                {data && closestEvents.length > 0 ? (
                    <CardContainer>
                        {closestEvents.map((event) => (
                            <EventCardListing key={event.event_id} eventId={event.event_id} />
                        ))}
                    </CardContainer>
                ) : (
                    <PlaceholderContainer>
                        <p>Hamarosan új események érkeznek!</p>
                    </PlaceholderContainer>
                )}
                <ButtonContainer>
                    <BasicButtonInverted onClick={handleClick}>További műsoraink</BasicButtonInverted>
                </ButtonContainer>
            </LoadingContainer>
        </Container>
    )
}
